export type HorizontalAlignmentType = 'left' | 'right' | 'center';
// top-bottom is used to place bottom line of the menu to the top of trigger element
export type VerticalAlignmentType = 'top' | 'bottom' | 'top-bottom' | 'middle';
export type MenuWidthType = 'auto' | 'full';
